import { render } from "./EditChartHeader.vue?vue&type=template&id=0e1a4da2"
import script from "./EditChartHeader.vue?vue&type=script&lang=js"
export * from "./EditChartHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__